import React, { useContext, useState } from "react";
import AIAVitalityModal from "../../../Modals/AIAVitalityModal/AIAVitalityModal";

//styles
import styles from "./AIAVitalityAddOn.module.scss";
import cx from "classnames";
import Icon from "../../../Icon/Icon";
import Checkbox from "../../../Forms/Checkbox/Checkbox";
import { IProviderAddon } from "../../../../../compare/interfaces/IProviderAddon";
import { QuoteGroupContext } from "../../../../../compare/providers/RootContextProvider";
import { selectProviderAddOnAPI } from "../../../../../compare/api/endpoints/ApiQuotes";
import { SplitTreatments } from "@splitsoftware/splitio-react";
import { FeatureFlag } from "../../../../../compare/enums/FeatureFlags";


interface IAIAVitalityCardProps {
    addOn: IProviderAddon;
    size: "small" | "full";
}

const AIAVitalityAddOn: React.FC<IAIAVitalityCardProps> = (props) => {
    const { addOn, size } = props;
    const { selectors, actions } = useContext(QuoteGroupContext);

    const [vitalityDetailsIsOpen, setVitalityDetailsIsOpen] = useState(false);
    const [isSelected, setIsSelected] = useState(selectors.isProviderAddOnSelected(addOn.systemName));

    const updateSelection = async (isSelected: boolean): Promise<void> => {
        setIsSelected(isSelected);
        actions.setIsProviderAddOnSelected(addOn.systemName, isSelected);

        const groupId = selectors.getGroupId();
        await selectProviderAddOnAPI(groupId, addOn.systemName, isSelected);
    };

    return (
        <SplitTreatments names={[FeatureFlag.AiaVitality]}>
            {({treatments, isReady}) => {
                if (window.splitioFactory && !isReady) return null;

                const treatment = treatments[FeatureFlag.AiaVitality].treatment;

                if (treatment === "on") {
                    return (
                        <React.Fragment>
                            <AIAVitalityModal
                                isOpen={vitalityDetailsIsOpen}
                                onClose={() => setVitalityDetailsIsOpen(false)}
                            />
                            <div className="layout-flex-row gap-m">
                                <Checkbox size="l" name="aia-vitality" checked={isSelected} onChange={(e) => updateSelection(e.target.checked)} />
                                <span className={cx(styles["mobile-heading"], "space-pre-m gap-pre-xs text-font-size-s text-bold")}>
                                    AIA Vitality
                                </span>
                            </div>
                            <span>LifeDirect will cover your first year's AIA Vitality fees. AIA Vitality includes a 10% discount for your first years' premiums. <a target="_blank" href="/article/lifedirect-aia-vitality-offer">T&Cs apply</a></span>
                            <a className={styles["more-info"]} onClick={() => setVitalityDetailsIsOpen(true)}> More info</a>
                        </React.Fragment>
                    );
                } else {
                    return (
                        <React.Fragment>
                            <AIAVitalityModal
                                isOpen={vitalityDetailsIsOpen}
                                onClose={() => setVitalityDetailsIsOpen(false)}
                            />

                            <div className={styles["aia-vitality-card-area"]}>
                                <Icon
                                    className={cx(styles["aia-vitality-icon"], "space-s", {
                                        [styles["aia-vitality-icon__small"]]: size === "small",
                                        [styles["aia-vitality-icon__full"]]: size === "full"
                                    })}
                                    id="AiaVitality"
                                />
                                <a onClick={() => setVitalityDetailsIsOpen(true)}>(optional)</a>
                            </div>
                            {size === "full" && <span>$11.50/month</span>}
                        </React.Fragment>
                    );
                }
                 
            }}

        </SplitTreatments>
        
    );
};

export default AIAVitalityAddOn;
